<template>
  <div>
    <img
      v-if="getUser.user_business.business_logo && !imgError"
      :src="getUser.user_business.business_logo"
      class="image"
      id="image-business"
      alt="Empresa"
      :width="width"
      @error="onImageError"
    />
    <div v-else class="initials-avatar">
      {{ initials }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      default: "200p"
    }
  },
  data: () => ({
    imgError: false
  }),
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    },
    initials() {
      const name = this.getUser.user_business.business_name || "";
      return name
        .split(" ")
        .slice(0, 2)
        .map(w => w.charAt(0).toUpperCase())
        .join("");
    }
  },
  methods: {
    onImageError(e) {
      e.target.style.display = "none";
      this.imgError = true;
    }
  }
};
</script>

<style scoped>
.initials-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e0f2f1;
  color: #00897b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
